<ng-container *ngIf="isLoading$ | async">
</ng-container>
<div class="home-slider owl-theme owl-carousel" >
    <div class="slider-item slider-item-img">
         <img src="assets/img/home-one/home-slider/s_01.jpg" alt="Shape">
    </div>
  <div class="slider-item slider-item-img">
        <img src="assets/img/home-one/home-slider/s_02.jpg" alt="Shape">
    </div>
      <div class="slider-item slider-item-img">
           <img src="assets/img/home-one/home-slider/s_03.jpg" alt="Shape">
    </div>
     <div class="slider-item slider-item-img">
           <img src="assets/img/home-one/home-slider/s_04.jpg" alt="Shape">
    </div>
     <div class="slider-item slider-item-img">
           <img src="assets/img/home-one/home-slider/s_05.jpg" alt="Shape">
    </div>
    <!-- <div class="slider-item slider-item-img">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                            <img src="assets/img/home-one/home-slider/website sliders-02.jpg" alt="Shape">
                </div>
            </div>
        </div>
    </div>

    <div class="slider-item slider-item-img">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                            <img src="assets/img/home-one/home-slider/website sliders-03.jpg" alt="Shape">
                </div>
            </div>
        </div>
    </div> -->
</div>

<section class="doctors-area ptb-100 shadow-box" >
    <div class="container text-center my-3">
        <div class="section-title">
            <h5 style="color: black !important;">{{ language == 'en'? '“Balsam” — What Soothes Pain and Revives the Spirit':
                '"بلسم " هو ما يسكّن الألم وينعش الروح ' }}</h5>
            <h2>{{ language == 'en'? 'When investment itself becomes a balsam ':
                'وعندما يكون الاستثمار بلسماً ' }}</h2>
             <h4 class="text-muted" style="text-align: justify;">{{ language == 'en'? 'it strengthens the healthcare ecosystem — both in capability and compassion. 
It empowers medical institutions to be closer, kinder, and more capable of giving — 
by enabling them and reshaping their future through smart investment tools. ':'فإنه يعزز للمنظومة الصحية قوتها وإنسانيتها 

ويمنح للمنشآت الطبية القدرة على أن تكون أقرب، أحنّ، وأقدر على العطاء، من خلال تمكينها وإعادة صياغة مستقبلها عبر أدوات الاستثمار الذكي ' }}</h4>
        </div>
    </div>
</section>

<section class="vm-section">
  <div class="container py-5 px-lg-5">

    <!-- الرؤية -->
    <div class="row align-items-center gy-4 mb-5">
      <!-- Text -->
      <div class="col-lg-6 order-2 order-lg-1">
        <h2 class="vm-title mb-3" >{{ language == 'en'? 'OUR VISION ':'رؤيتنا' }}</h2>
        <p class="text-muted" style="text-align: justify">
          {{ language == 'en'? 'To be the premier and most trusted healthcare investment platform, empowering investors to access 

transformative healthcare opportunities. By strategically raising and actively supporting a diversified 

portfolio of market-leading healthcare businesses, we will redefine the standard of healthcare 

investment and positively impact the well-being of the communities we serve. ':
                                        'أن نكون منصة الاستثمار الأمثل في مجال الرعاية الصحية، لتمكين مستثمريها من الوصول إلى فرص مميزة. سنعيد تشكيل معايير الاستثمار في الرعاية الصحية لتؤثر بشكل إيجابي على الصحة العامة من خلال محفظة متنوعة.' }}
        </p>
      </div>
      <!-- Image + Corner Tag -->
      <div class="col-lg-6 order-1 order-lg-2">
        <div class="vm-photo-card">
          <img src="assets/img/home-one/Vision.jpg" />
          <!-- <div class="corner-tag">
            <span style="color: rgb(182, 142, 39) !important;">{{ language == 'en'? 'OUR VISION ':'رؤيتنا' }}</span>
            <span class="tag-icon"><i class="icofont-eye"></i></span>
          </div> -->
        </div>
      </div>
    </div>

    <!-- الرسالة (معكوسة) -->
    <div class="row align-items-center gy-4">
      <!-- Image + Corner Tag -->
      <div class="col-lg-6">
        <div class="vm-photo-card">
          <img src="assets/img/home-one/Mission.jpg" />
          <!-- <div class="corner-tag">
            <span class="tag-text">{{ language == 'en'? 'OUR MISSION ':'رسالتنا' }}</span>
            <span class="tag-icon danger"><i class="icofont-bullseye"></i></span>
          </div> -->
        </div>
      </div>
      <!-- Text -->
      <div class="col-lg-6">
        <h2 class="vm-title mb-3">{{ language == 'en'? 'OUR MISSION ':'رسالتنا' }}</h2>
        <p class="text-muted" style="text-align: justify">
         {{ language == 'en'? 'Wisely invest in and actively support a diversified portfolio of market-leading healthcare businesses. 

Guided by our core principles of integrity, impact, and a relentless pursuit of excellence, we strive to 

deliver sustainable growth and additional shareholder value, while championing healthcare investment 

solutions that enhance lives. ':
                                        'نستثمر وندعم محفظة متنوعة من فرص الرعاية الصحية المتميزة. مسترشدين بمبادئنا الأساسية المتمثلة في الحكمة والنزاهة والتأثير والسعي الحثيث لتحقيق التميز. نسعى جاهدين لتحقيق نمو مستدام وقيمة إضافية لحقوق المساهمين مع دعم الحلول التي تعزز الحياة.' }}
        </p>
      </div>
    </div>

  </div>
</section>
<section class="values-section" >
  <div class="container-fluid px-0">
    <div class="values-hero py-4 text-center">
      <h2 class="values-title">{{ language == 'en'? 'OUR VALUES ':'قيمنا ' }}</h2>
    </div>

    <div class="values-slider container position-relative py-4">
      <!-- Prev -->
      <button dir="ltr" class="nav-btn prev"  (click)="prev()" [disabled]="atStart" aria-label="السابق">
        <i class="icofont-long-arrow-left"></i>
      </button>

      <!-- Next -->
      <button dir="ltr" class="nav-btn next" (click)="next()" [disabled]="atEnd" aria-label="التالي">
        <i class="icofont-long-arrow-right"></i>
      </button>

      <div class="viewport" dir="ltr" >
        <div class="track" [style.transform]="transform">
          <article class="value-card" *ngFor="let v of values">
            <div class="icon-wrap"><i class="{{ v.icon }}"></i></div>
            <h3 class="value-title">{{ v.title }}</h3>
            <!-- <p class="value-text mb-0">{{ v.text }}</p> -->
          </article>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <div class="container py-5" style="margin-top: 50px !important;">
  <div class="main-row">
    <div class="circle-box">
      <div>
        <h3>{{ language == 'en'? 'OUR MISSION ':'رسالتنا' }}</h3>
        <p class="text-muted">{{ language == 'en'? 'We invest in and support a diverse portfolio of distinguished healthcare opportunities. Guided by our core principles of wisdom, integrity, impact, and relentless pursuit of excellence. We strive to achieve sustainable growth and add value for our shareholders while supporting solutions that enhance life.':
                                        'نستثمر وندعم محفظة متنوعة من فرص الرعاية الصحية المتميزة. مسترشدين بمبادئنا الأساسية المتمثلة في الحكمة والنزاهة والتأثير والسعي الحثيث لتحقيق التميز. نسعى جاهدين لتحقيق نمو مستدام وقيمة إضافية لحقوق المساهمين مع دعم الحلول التي تعزز الحياة.' }}</p>
      </div>
    </div>

    <div class="values-orbit">
      <div class="center-core">{{ language == 'en'? 'OUR VALUES ':'قيمنا ' }}</div>
      <div class="orbit-wrapper">
        <div class="orbit-dot"><span>{{ language == 'en'? 'Wisdom ':' الحكمة' }}</span></div>
        <div class="orbit-dot"><span>{{ language == 'en'? 'Integrity  ':'النزاهة' }}</span></div>
        <div class="orbit-dot"><span>{{ language == 'en'? 'Excellence ':'التميز' }}</span></div>
        <div class="orbit-dot"><span>{{ language == 'en'? 'Collaboration ':'التعاون' }}</span></div>
        <div class="orbit-dot"><span>{{ language == 'en'? 'Impact ':'التأثير' }}</span></div>
        <div class="orbit-dot"><span>{{ language == 'en'? 'Excellence ':'التميز' }}</span></div>
      </div>
    </div>
    <div class="circle-box">
      <div>
        <h3>{{ language == 'en'? 'OUR VISION ':'رؤيتنا' }}</h3>
        <p class="text-muted">{{ language == 'en'? 'To be the optimal investment platform in the healthcare sector, to enable our investors to access distinctive opportunities. We will reshape the standards of investing in healthcare to positively impact public health through a diverse portfolio.':
                                        'أن نكون منصة الاستثمار الامثل في مجال الرعاية الصحية، لتمكين مستثمريها من الوصول إلى فرص مميزة. سنعيد تشكيل معايير الاستثمار في الرعاية الصحية لتؤثر بشكل إيجابي على الصحة العامة من خلال محفظة متنوعة.' }}</p>
      </div>
    </div>
  </div>
</div> -->

<div class="container py-5">
  <div class="row align-items-center rounded-4 shadow-sm p-4 position-relative overflow-hidden text-white" style="background-color: rgba(0, 0, 0, 0.85);">
    
    <!-- Decorative Layer (optional) -->
    <div class="position-absolute top-0 start-0 w-100 h-100" style="background-color: rgba(0, 0, 0, 0.1)"></div>

    <!-- Text Section -->
    <div class="col-md-7 px-4 position-relative" style="z-index: 1;">
      <h3 class="fw-bold mb-3" style="color: rgb(182 142 39) !important;">
        {{ language == 'en'? 'Chairman’s Message': 'رسالة رئيس مجلس الإدارة ' }}
        </h3>
      <p style="color: #fff !important;text-align: justify;">
        {{ language == 'en'? 'We are establishing a unique investment platform that transforms traditional healthcare assets into an integrated, high-performance ecosystem. 
Our dual business model, combining operations and investment, grants us exceptional flexibility and the ability to capture promising opportunities, while maintaining a careful balance between stable cash flows from our operational assets and high-growth returns from our strategic investments in health technologies and pharmaceutical industries. 

Our commitment to integrity and adherence to the highest standards of corporate governance are not merely part of our identity — they are the assurance we offer our shareholders that their investments are in safe hands, dedicated to maximizing value and reinforcing positive impact. ': 'نحن نؤسس لمنصة استثمارية فريدة من نوعها، تحوّل الأصول الصحية التقليدية إلى منظومة متكاملة وعالية الأداء. نموذج عملنا المزدوج، الذي يجمع بين التشغيل والاستثمار، يمنحنا مرونة استثنائية وقدرة على اقتناص الفرص الواعدة، مع تحقيق توازن دقيق بين التدفقات النقدية المستقرة من أصولنا التشغيلية، وعوائد النمو المرتفعة من استثماراتنا الاستراتيجية في التقنيات الصحية والصناعات الدوائية. 

إن التزامنا بالنزاهة، وتطبيقنا لأعلى معايير الحوكمة المؤسسية، لا يمثل فقط جزءاً من هويتنا، بل هو الضمانة التي نقدمها لمساهمينا بأن استثماراتهم في أيدٍ أمينة تسعى لتعظيم القيمة وترسيخ الأثر الإيجابي.' }}

        
      </p>
      <p class="fw-semibold mt-4" [ngClass]=" language == 'en'? 'ChairmanEn' : 'ChairmanAr'" style="color: rgb(182 142 39) !important;">
        {{ language == 'en'? 'Mr. Khalid Abdullah Al-Otaibi': 'أ. خالد عبد الله العتيبي' }}
        </p>
        <p class="fw-semibold" [ngClass]=" language == 'en'? 'ChairmanEn' : 'ChairmanAr'" style="font-size: 16px;color: rgb(182 142 39) !important;margin-top: -20px;">
        {{ language == 'en'? 'Chairman of the Board': 'رئيس مجلس الإدارة' }}
        </p>
    </div>

    <!-- Image Section -->
    <div class="col-md-5 text-center position-relative" style="z-index: 1;">
      <div class="p-3">
        <img src="assets/img/CEO.jpg" alt="CEO" class="img-fluid rounded-circle border border-3 border-white shadow" style="width: 250px;height: 250px;">
      </div>
    </div>

  </div>
</div>

<div class="counter-area" style="margin-top: 120px;">
    <div class="container">
        <div class="row counter-bg">
            <div class="col-sm-4 col-lg-3">
                <div class="counter-item">
                    <!-- <i class="icofont-hospital"></i> -->
                    <img src="assets/img/home-one/CLINICKS.png" alt="CLINICKS" height="80px" width="80px">
                    <h3 style="direction: rtl !important"><span class="counter">{{ EnvService.SpecialtiesCount }}</span>+</h3>
                    <p>{{'ABOUTUS.CLINICKS' | translate}}</p>
                </div>
            </div>
            <div class="col-sm-4 col-lg-2">
                <div class="counter-item">
                    <!-- <i class="icofont-hospital"></i> -->
                    <img src="assets/img/home-one/HealthcareFacilities.png" alt="CLINICKS" height="80px" width="80px">
                    <h3 style="direction: rtl !important"><span class="counter">{{ EnvService.HealthcareFacilitiesCount }}</span>+</h3>
                    <p>{{ language == 'en'? 'Healthcare Facilities':
                'مرافق الرعاية الصحية' }}</p>
                </div>
            </div>
             <div class="col-sm-4 col-lg-3">
                <div class="counter-item">
                    <!-- <i class="icofont-hospital"></i> -->
                    <img src="assets/img/home-one/GeographicExpansion.png" alt="CLINICKS" height="80px" width="80px">
                    <h3 style="direction: rtl !important"><span class="counter">{{ EnvService.OperationalCitiesCount }}</span>+</h3>
                    <p>{{ language == 'en'? 'City':
                'مدينة' }}</p>
                </div>
            </div>
            <div class="col-sm-4 col-lg-2">
                <div class="counter-item">
                    <img src="assets/img/home-one/DOCTORSANDNURSE.png" alt="DOCTORS" height="80px" width="80px">
                    <!-- <i class="icofont-doctor-alt"></i> -->
                    <h3 style="direction: rtl !important"><span class="counter">{{ EnvService.StaffMembersCount }}</span>+</h3>
                    <p>{{'ABOUTUS.DOCTORSANDNURSE' | translate}}</p>
                </div>
            </div>
            <div class="col-sm-4 col-lg-2">
                <div class="counter-item">
                    <!-- <i class="icofont-patient-bed"></i> -->
                    <img src="assets/img/home-one/PATIENTSBEDS.png" alt="PATIENTSBEDS" height="80px" width="80px">
                    <h3 style="direction: rtl !important;"><span class="counter">{{ EnvService.BedsCount }}</span>+</h3>
                    <p>{{'ABOUTUS.PATIENTSBEDS' | translate}}</p>
                </div>
            </div>

            <!-- <div class="col-sm-4 col-lg-2">
                <div class="counter-item">
                    <img src="assets/img/home-one/EMPLOYEES.png" alt="EMPLOYEES" height="80px" width="80px">
                    <h3 style="direction: rtl !important;"><span class="counter">{{ EnvService.AnnualPatientVisitsCount }}</span>+</h3>
                    <p>{{'ABOUTUS.EMPLOYEES' | translate}}</p>
                </div>
            </div> -->

        </div>
    </div>
    <!-- <div class="container">
        <div class="row counter-bg">
            <div class="col-sm-6 col-md-3 col-lg-3">
                <div class="counter-item">
                    <i class="icofont-patient-bed"></i>
                    <h3 class="counter">850</h3>
                    <p>Patients Beds</p>
                </div>
            </div>

            <div class="col-sm-6 col-md-3 col-lg-3">
                <div class="counter-item">
                    <i class="icofont-people"></i>
                    <h3><span class="counter">25000</span>+</h3>
                    <p>Happy Patients</p>
                </div>
            </div>

            <div class="col-sm-6 col-md-3 col-lg-3">
                <div class="counter-item">
                    <i class="icofont-doctor-alt"></i>
                    <h3 class="counter">750</h3>
                    <p>Doctors  & Nurse</p>
                </div>
            </div>

            <div class="col-sm-6 col-md-3 col-lg-3">
                <div class="counter-item">
                    <i class="icofont-badge"></i>
                    <h3 class="counter">18</h3>
                    <p>Year Experience</p>
                </div>
            </div>
        </div>
    </div> -->
</div>
<!-- <section class="doctors-area ptb-100 text-center" style="margin-top: -80px;">
    <div class="container text-center">
        <div class="section-title">
            <h2>{{ language == 'en'? 'Accreditations':
                'الاعتمادات' }}</h2>
        </div>
         <div class="container text-center my-3 rad">
            <img src="assets/img/home-one/home-bg7.jpg" alt="Shape">
          </div> 
        
    </div>
</section> -->
<!-- <section class="doctors-area ptb-100 text-center" style="margin-top: -80px;">
    <div class="container text-center">
        <div class="section-title">
            <h2>{{ language == 'en'? 'Our Hospitals':
                'مستشفياتنا' }}</h2>
        </div>
        <div class="row">
            <div class="col-lg-6 rad" style="margin-bottom: 30px;">
                <div class="Medical-info">
                    <img src="assets/img/home-one/FCH.jpeg" alt="Shape">
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-6"><h4>{{ language =='ar' ? 'مستشفى عناية العائلة' : 'Family Care Hospital'}}</h4></div>
                        <div class="col-lg-6"> <i class="icofont-location-pin med" style="font-size: 30px;"></i>
                            <label style="font-size: 18px;">{{ language =='ar' ? 'الرياض' : 'Riyadh'}}</label></div>
                    </div>
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-3">
                            <img src="assets/img/home-one/1.jpg" alt="Shape">
                            <p>100</p>
                        </div>
                        <div class="col-lg-3">
                            <img src="assets/img/home-one/2.jpg" alt="Shape">
                            <p>27</p>
                        </div>
                        <div class="col-lg-3">
                            <img src="assets/img/home-one/3.jpg" alt="Shape">
                            <p>192</p>
                        </div>
                        <div class="col-lg-3">
                            <img src="assets/img/home-one/4.jpg" alt="Shape">
                            <p>+1M</p>
                        </div>
                    </div>
                </div>               
            </div>
            <div class="col-lg-6 rad" style="margin-bottom: 30px;">
                <div class="Medical-info">
                    <img src="assets/img/home-one/AlAhly.jpeg" alt="Shape">
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-7"><h4>{{ language =='ar' ? 'مستشفى الخفجي الأهلي' : 'Al Khafji National Hospital'}}</h4></div>
                        <div class="col-lg-5"> <i class="icofont-location-pin med"  style="font-size: 30px;"></i>
                            <label style="font-size:18px;">{{ language =='ar' ? 'الخفجي' : 'Al Khafji'}}</label></div>
                    </div>
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-3">
                            <img src="assets/img/home-one/1.jpg" alt="Shape">
                            <p>30</p>
                        </div>
                        <div class="col-lg-3">
                            <img src="assets/img/home-one/2.jpg" alt="Shape">
                            <p>18</p>
                        </div>
                        <div class="col-lg-3">
                            <img src="assets/img/home-one/3.jpg" alt="Shape">
                            <p>58</p>
                        </div>
                        <div class="col-lg-3">
                            <img src="assets/img/home-one/4.jpg" alt="Shape">
                            <p>+154K</p>
                        </div>
                    </div>
                </div>          
            </div>    
        </div>  
    </div>
</section> -->

<!-- <section class="doctors-area ptb-100 text-center" style="margin-top: -80px;">
    <div class="container text-center">
        <div class="section-title">
            <h2>{{ language == 'en'? 'Our Medical Centers':
                'مراكزنا الطبية' }}</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 rad " style="margin-bottom: 30px;">
                <div class="Medical-info">
                    <img src="assets/img/home-one/1.jpeg" alt="Shape">
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-7"><label>{{ language =='ar' ? 'مجمع درياق الطبي ' : 'Daryak Medical Center'}}</label></div>
                        <div class="col-lg-5"> <i class="icofont-location-pin"></i>
                            <label>{{ language =='ar' ? 'النماص' : 'Al-Namas'}}</label></div>
                    </div>
                </div>
                
            </div>
            <div class="col-lg-4 rad" style="margin-bottom: 30px;">
                <div class="Medical-info">
                    <img src="assets/img/home-one/2.jpeg" alt="Shape">
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-7"><label>{{ language =='ar' ? 'مجمع درياق الطبي ' : 'Daryak Medical Center'}}</label></div>
                        <div class="col-lg-5"> <i class="icofont-location-pin"></i>
                            <label>{{ language =='ar' ? 'جدة' : 'Jeddah'}}</label></div>
                    </div>
                </div>
                
            </div>
            <div class="col-lg-4 rad" style="margin-bottom: 30px;">
                <div class="Medical-info">
                    <img src="assets/img/home-one/3.jpeg" alt="Shape">
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-7"><label>{{ language =='ar' ? 'مجمع درياق الطبي ' : 'Daryak Medical Center'}}</label></div>
                        <div class="col-lg-5"> <i class="icofont-location-pin"></i>
                            <label>{{ language =='ar' ? 'سراة عبيدة' : 'Sarat Obaida'}}</label></div>
                    </div>
                </div>
                
            </div>
            <div class="col-lg-4 rad" style="margin-bottom: 30px;">
                <div class="Medical-info">
                    <img src="assets/img/home-one/4.jpeg" alt="Shape">
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-7"><label>{{ language =='ar' ? 'مجمع النزهة الطبي' : 'Al Nozha Medical Center'}}</label></div>
                        <div class="col-lg-5"> <i class="icofont-location-pin"></i>
                            <label>{{ language =='ar' ? 'الرياض' : 'Riyadh'}}</label></div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 rad" style="margin-bottom: 30px;">
                <div class="Medical-info">
                    <img src="assets/img/home-one/5.jpeg" alt="Shape">
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-5"><label>{{ language =='ar' ? 'مجمع بلسم' : 'Balsam Center'}}</label></div>
                        <div class="col-lg-6"> <i class="icofont-location-pin"></i>
                            <label>{{ language =='ar' ? 'خميس مشيط' : 'Khamis Mushayt'}}</label></div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 rad" style="margin-bottom: 30px;">
                <div class="Medical-info">
                    <img src="assets/img/home-one/6.jpeg" alt="Shape">
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-5"><label>{{ language =='ar' ? 'مجمع الدمام' : 'Dammam Center'}}</label></div>
                        <div class="col-lg-6"> <i class="icofont-location-pin"></i>
                            <label>{{ language =='ar' ? 'الدمام' : 'Dammam'}}</label></div>
                    </div>
                </div>
                
            </div>
            <div class="col-lg-4 rad" style="margin-bottom: 30px;">
                <div class="Medical-info">
                    <img src="assets/img/home-one/7.jpeg" alt="Shape">
                    <div class="row " style="margin-top: 20px;">
                        <div class="col-lg-7"><label>{{ language =='ar' ? 'مجمع درياق الطبي ' : 'Daryak Medical Center'}}</label></div>
                        <div class="col-lg-5"> <i class="icofont-location-pin"></i>
                            <label>{{ language =='ar' ? 'ظهران الجنوب' : 'South Dahran'}}</label></div>
                    </div>
                </div>
                
            </div>
        </div>
        
    </div>
</section> -->

<!-- <section class="doctors-area ptb-100" style="margin-top: -80px;">
    <div class="container">
        <div class="section-title">
            <h2>{{ language == 'en'? 'Our Network':
                'شبكتنا' }}</h2>
        </div>
         <div class="container text-center my-3">
            <div class="row mx-auto my-auto justify-content-center">
              <div id="HospitalNews" class="carousel slide HospitalNewscarousel" data-bs-ride="carousel">
                <div class="carousel-inner HospitalNewscarousel-inner" role="listbox">
                  <div
                  
                    class="carousel-item HospitalNewscarousel-item"
                    [ngClass]="{ active: i == 0 }"
                    *ngFor="let New of HospitalNews; let i = index"
                  >
                    <div class="col-md-4 col-sm-12" >
                      <div class="card">
                        <div class="card-img">
                            <img *ngIf="New.imagePath != null;else NewsImagePath" [src]="New.imagePath | SafeUrlPipe" alt="News" >
                        <ng-template #NewsImagePath><img src="assets/img/DefaultImage.png" alt="News" height="250px" width="350px"></ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <a
                  class="carousel-control-prev bg-transparent w-aut"
                  href="#HospitalNews"
                  role="button"
                  data-bs-slide="prev"
                  style="left: -7pc;"
                >
                  <span style="background-color: rgb(182 142 39) !important;border-radius: 50%;padding: 25px;" class="carousel-control-prev-icon" aria-hidden="true"></span>
                </a>
                <a
                  class="carousel-control-next bg-transparent w-aut"
                  href="#HospitalNews"
                  role="button"
                  data-bs-slide="next"
                  style="right: -7pc;"
                >
                  <span style="background-color: rgb(182 142 39) !important;border-radius: 50%;padding: 25px;" class="carousel-control-next-icon" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </div> 
      
    </div>
</section> -->
<!-- <div class="video-wrap">
    <div class="container-fluid p-0">
        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-about" role="tabpanel" aria-labelledby="pills-about-tab">
                <div class="video-area">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="container">
                                <div class="video-item">

                                    <div class="video-content">
                                        <h3>{{ language == 'en'? 'ABOUT HOSPITAL':
                                            'عن المستشفى' }}</h3>
                                        <p style="text-align: justify;">{{ language == 'en'? 'The Family Care Hospital Team, Are Proud to Harness All Our Capabilities to Provide High-Level Services That Are in Line with The Vision of The Kingdom of Saudi Arabia “2030” Pursued by Our Wise Government, Which Aims to Achieve a Future Vision to Provide Integrated and Comprehensive Health Care at The Highest International Standards.':
                                            'فريق مستشفى عناية العائلة تفخر بأن تسخر كافة إمكانياتها لتقديم خدمات عالية المستوى والتي تتماشى مع رؤية المملكة العربية السعودية ” 2030 ” التي تنتهجها حكومتنا الرشيدة والتي تهدف إلى تحقيق رؤية مستقبلية لتوفير الرعاية الصحية المتكاملة والشاملة بأعلى المستويات العالمية لجميع أفراد المجتمع.' }} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="pills-lab" role="tabpanel" aria-labelledby="pills-lab-tab">
                <div class="video-area">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="container">
                                <div class="video-item">

                                    <div class="video-content">
                                        <h3>{{ language == 'en'? 'LABORATORY':
                                            'المختبر' }}</h3>
                                        <p style="text-align: justify;">{{ language == 'en'? 'In our Laboratory We Work at A High Level of Accuracy & Efficiency Using Equipment with The Latest Modern Technologies in The Science of Laboratory Medicine, Which Contribute Greatly to Accurate Diagnosis & Treatment According to The Highest Standards in Quality Under the Supervision of Consultants, Specialists & Technicians.':
                                            'نعمل على مستوى عال من الدقة والكفاءة والمزود بأحدث التقنيات الحديثة في علم الطب المخبري  التى تسهم وبشكل كبير في التشخيص الدقيق والعلاج وفقا لاعلي المعايير في الجودة  تحت إشراف نخبة من الاستشاريين والأخصائيين والفنيين.' }} </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="pills-radiology" role="tabpanel" aria-labelledby="pills-radiology-tab">
                <div class="video-area">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="container">
                                <div class="video-item">

                                    <div class="video-content">
                                        <h3>{{ language == 'en'? 'RADIOLOGY ':
                                            'الأشعة' }}</h3>
                                        <p style="text-align: justify;">{{ language == 'en'? 'The Radiology Department at Family Care Hospital Includes Modern Devices, Technologies & Specialized Staff to Serve Patients & Visitors, While Ensuring the Application of The Highest Standards of Quality & Safety in Diagnosis & To Ensure Accuracy in The Medical Results Provided to Patients, Which Makes the Radiology Department a Distinguished Character with High Efficiency & The Advancement of Its Services in Addition to The Distinguished Scientific & Practical Reputation.':
                                            'يضم قسم الأشعة بمستشفى عناية العائلة على الأجهزة والتقنيات الحديثة وكادر متخصصين  لخدمة المرضى والمراجعين مع الحرص على تطبيق أعلى معايير الجودة والسلامة في التشخيص ولضمان الدقة فى النتائج الطبية المقدمة للمرضي ، مما يجعل  لقسم  الأشعة الطابع  المميز  ذو الكفاءة العالية ورقي خدماته بالإضافة إلى السمعة العلمية والعملية المتميزة.' }} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="pills-icu" role="tabpanel" aria-labelledby="pills-icu-tab">
                <div class="video-area">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="container">
                                <div class="video-item">

                                    <div class="video-content">
                                        <h3>{{ language == 'en'? 'INTENSIVE CARE UNIT':
                                            'وحدة العناية المركزة' }}</h3>
                                        <p style="text-align: justify;">{{ language == 'en'? 'The intensive care unit is one of the most important departments of the Family Care Hospital, where we provide effective intensive care services that include consultations for all patients through a staff of qualified doctors & nurses to deal with the most difficult & complex cases 24 hours/day, where medical service is provided to inpatients with cooperation & communication with Various medical services through the latest & modern medical technologies. Where the intensive care unit includes separate wings to reduce the possibility of infection & increase the level of privacy and calmness, in addition to the availability of patient beds that are designed to achieve the highest safety standards.':
                                            'يعتبر وحدة العناية المركزة أحد أهم أقسام مستشفى عناية العائلة حيث نقدم خدمات الرعاية المركزة الفعالة يشمل على استشارات لجميع المرضى  من خلال طاقم من الأطباء والممرضين المؤهلين للتعامل مع أصعب الحالات وأكثرها تعقيدًا على مدار الساعة، حيث يتم تقديم الخدمة الطبية للمرضى المنومين بالتعاون المكثف والتواصل بين التخصصات الطبية المختلفة من خلال أحدث التقنيات الطبية الحديثة حيث يتضمن وحدة العناية المركزة أجنحة منفصلة لتقلل من احتمالات العدوى وتزيد من مستوى الخصوصية والهدوء بالإضافة إلى توفر أسرة المرضى المصممة على نحو فريد لييحقق أعلى معايير السلامة.' }} </p>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="pills-pharmacy" role="tabpanel" aria-labelledby="pills-pharmacy-tab">
                <div class="video-area">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="container">
                                <div class="video-item">

                                    <div class="video-content">
                                        <h3>{{ language == 'en'? 'PHARMACY':
                                            'الصيدلية' }}</h3>
                                        <p style="text-align: justify;">{{ language == 'en'? 'In pharmacy department of Family Care Hospital, we seek to provide excellent therapeutic & pharmaceutical services to our valued customers 24 hours, including outpatient clinics & inpatient departments.':
                                            'نسعى في قسم الصيدلة بمستشفى عناية العائلة بتقديم خدمات علاجية وصيدلية متميزة لعملائنا الكرام على مدار الساعة من مرضى العيادات الخارجية والأقسام الداخلية.' }} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="container">
        <ul class="video-nav nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item video-nav-item">
                <button class="nav-link active" id="pills-about-tab" data-bs-toggle="tab" data-bs-target="#pills-about" type="button" role="tab" aria-controls="pills-about" aria-selected="true">{{ language == 'en'? 'ABOUT HOSPITAL':
                    'عن المستشفى' }}</button>
            </li>

            <li class="nav-item video-nav-item">
                <button class="nav-link" id="pills-lab-tab" data-bs-toggle="tab" data-bs-target="#pills-lab" type="button" role="tab" aria-controls="pills-lab" aria-selected="true">{{ language == 'en'? 'LABORATORY ':
                    'المختبر' }}</button>
            </li>

            <li class="nav-item video-nav-item">
                <button class="nav-link" id="pills-radiology-tab" data-bs-toggle="tab" data-bs-target="#pills-radiology" type="button" role="tab" aria-controls="pills-radiology" aria-selected="true">{{ language == 'en'? 'RADIOLOGY ':
                    'الأشعة' }}</button>
            </li>

            <li class="nav-item video-nav-item">
                <button class="nav-link" id="pills-icu-tab" data-bs-toggle="tab" data-bs-target="#pills-icu" type="button" role="tab" aria-controls="pills-icu" aria-selected="true">{{ language == 'en'? 'INTENSIVE CARE UNIT':
                    'وحدة العناية المركزة' }}</button>
            </li>

            <li class="nav-item video-nav-item">
                <button class="nav-link" id="pills-pharmacy-tab" data-bs-toggle="tab" data-bs-target="#pills-pharmacy" type="button" role="tab" aria-controls="pills-pharmacy" aria-selected="true">{{ language == 'en'? 'PHARMACY':
                    'الصيدلية' }}</button>
            </li>
        </ul>
    </div>
</div> -->

<!-- <section class="doctors-area ptb-100" >
    <div class="container">
        <div class="section-title">
            <h2>{{ language == 'en'? 'Partners':
                'شركاؤنا' }}</h2>
        </div>
        
<div class="container text-center my-3">
    <div class="row mx-auto my-auto justify-content-center">
      <div id="recipeCarousel" class="carousel slide HospitalPartnerscarousel" data-bs-ride="carousel" data-interval="1000">
        <div class="carousel-inner HospitalPartnerscarousel-inner" role="listbox">
          <div
          
            class="carousel-item HospitalPartnerscarousel-item"
            [ngClass]="{ active: i == 0 }"
            *ngFor="let Partner of HospitalPartners; let i = index"
          >
            <div class="col-md-3 col-sm-12" >
              <div class="card">
                <div class="card-img">
                    <img *ngIf="Partner.imagePath != null;else PartnerImagePath" [src]="Partner.imagePath | SafeUrlPipe" alt="Partner">
                    <ng-template #PartnerImagePath><img src="assets/img/DefaultImage.png" alt="Partner" height="250px" width="350px"></ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev bg-transparent w-aut"
          href="#recipeCarousel"
          role="button"
          data-bs-slide="prev"
          style="left: -7pc;"
        >
          <span style="background-color: rgb(182 142 39) !important;border-radius: 50%;padding: 25px;" class="carousel-control-prev-icon" aria-hidden="true"></span>
        </a>
        <a
          class="carousel-control-next bg-transparent w-aut"
          href="#recipeCarousel"
          role="button"
          data-bs-slide="next"
          style="right: -7pc;"
        >
          <span style="background-color: rgb(182 142 39) !important;border-radius: 50%;padding: 25px;" class="carousel-control-next-icon" aria-hidden="true"></span>
        </a>
      </div>
    </div>
  </div>
       
    </div>
</section> -->